import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import { Select } from '@components/atoms/select'
import { minMaxOptions } from '@config/data'
import { MultiCheckBox } from '@components/atoms/multi-checkbox'
import { Checkbox } from '@components/atoms/checkbox'
import { TextField } from '@components/atoms/text-field'

const list = [
  {
    name: 'running',
    label: 'Running'
  },
  {
    name: 'biking',
    label: 'Biking'
  },
  {
    name: 'elliptical',
    label: 'Elliptical'
  },
  {
    name: 'runningHIIT',
    label: 'Running HIIT',
    info: <div>Running High-Intensity Interval Training (HIIT) is an efficient cardiovascular workout that alternates between intense running and recovery periods. It helps improve fitness, burn calories, and increase endurance. A typical HIIT session includes short bursts of sprinting (20-60 seconds) followed by slower-paced jogging or walking for an equal or slightly longer duration, repeated for 20-30 minutes. Suitable for all fitness levels, HIIT maximizes results in a shorter time compared to traditional cardio workouts.</div>
  },
  {
    name: 'otherHIIT',
    label: 'Other HIIT',
    info: <div>High-Intensity Interval Training (HIIT) is an efficient cardiovascular workout that alternates between intense exercise and recovery periods, improving fitness, burning calories, and increasing endurance. A typical HIIT session includes short bursts (20-60 seconds) of various non-running activities, such as jump rope, burpees, mountain climbers, bicycle crunches, and box jumps, followed by a slower-paced recovery period for an equal or slightly longer duration, repeated for 20-30 minutes. Suitable for all fitness levels, HIIT maximizes results in a shorter time compared to traditional cardio workouts.</div>
  },
];

export const Cardio = memo(({ state, onChange }) => {
  return (
    <>
      <ReactTooltip
        id="tooltip"
        place="top"
        type="dark"
        effect="solid"
      />
      <div className="text-slate-600" data-tooltip-id="tooltip" data-tooltip-content=''>How many days a week will you commit to cardio workouts?</div>
      <div className="flex space-x-4 mt-8">
        <Select
          name="cardioMin"
          label="Min"
          value={state.cardioMin}
          onChange={onChange}
          list={minMaxOptions}
        />
        <Select
          name="cardioMax"
          label="Max"
          value={state.cardioMax}
          onChange={onChange}
          list={minMaxOptions.slice(state.cardioMin)}
        />
      </div>
      <div className="text-slate-600" data-tooltip-target="tooltip-test">What type of cardio will you do?</div>
      <div id="tooltip-default" role="tooltip" className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
        Tooltip content
        <div className="tooltip-arrow" data-popper-arrow />
      </div>
      <div className="mt-4 flex flex-col space-y-4">
        <MultiCheckBox
          name="cardioTypes"
          value={state.cardioTypes}
          onChange={onChange}
          list={list}
        />
        <div className="flex w-64">
          <Checkbox
            value={state.cardioTypesOption1}
          />
          <TextField
            placeholder="Other"
            name="cardioTypesOption1"
            onChange={onChange}
            value={state.cardioTypesOption1}
          />
        </div>
        <div className="flex w-64">
          <Checkbox
            value={state.cardioTypesOption2}
          />
          <TextField
            placeholder="Other"
            name="cardioTypesOption2"
            onChange={onChange}
            value={state.cardioTypesOption2}
          />
        </div>
        <div className="flex w-64">
          <Checkbox
            value={state.cardioTypesOption3}
          />
          <TextField
            placeholder="Other"
            name="cardioTypesOption3"
            onChange={onChange}
            value={state.cardioTypesOption3}
          />
        </div>
      </div>
    </>
  )
})



Cardio.propTypes = {
  state: PropTypes.object,
  onChange: PropTypes.func
}